import React,{useState,useEffect,useContext} from 'react'
import noteContext from '../contex/notes/noteContext'
import { Link, useLocation } from "react-router-dom";
const Navabar = () => {

// Context api
  const context = useContext(noteContext)
  const{ relod , setrelod,userdetail , setuserData , setauthtoken}  = context

// to reload Navbar component after login / signup
if(relod===true){
   window.location.reload(true);
   setrelod(false)
}
useEffect(() => {
  GetuseDetail()
    
  }, [])

//  An Experiment i am per forming 
const [data, setData] = useState({name: null});
  const GetuseDetail = async()=>{
    const authtoken = localStorage.getItem("token");

    if(authtoken!=null){
      setauthtoken(authtoken)
    }

    const response = await fetch('https://imanager-api-z2gy.onrender.com/api/auth/getuser',{
     method:"POST",
     headers:{
       'Content-Type': 'application/json',
     'auth-token':authtoken
     }
    })
    const parsedata = await response.json()
    
       if(parsedata.error){
         data({name:null})
       }else{
         setData(parsedata)
         setuserData(parsedata)
         
       }
 }

 // setting up login and signup for non registered users
    const detailnav = ()=>{
       if(!userdetail.name){
        return( <Link to="/signup" style={{textDecoration : "none" , color:"#ffffff"}} className="font-monospace" >{data.name}</Link>)
       }
    }

    let location = useLocation()
  return (
    <>
    <nav style={{ boxShadow:" 0px 0.1px 3px black" , backgroundColor:"#ffffff40"}} className="navbar navbar  navbar-expand-lg p-1">
        <div className="container-fluid">
            <Link to="/" className="navbar-brand fs-3 fw-light" style={{color:"#fcfcfc" , fontFamily: "fantasy"}}  >I-Manager</Link>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                <li className="nav-item">
                <Link className={`nav-link ${location.pathname==="/Diary"? "active": ""} fs-5 font-monospace mx-2`}  to="/Diary">Diary</Link>
                </li>
                <li className="nav-item">
                <Link className={`nav-link ${location.pathname==="/To-do"? "active": ""} fs-5 font-monospace mx-2`}  to="/To-do">To-Do List</Link>
                </li>
                <li className="nav-item">
                <Link className={`nav-link ${location.pathname==="/Notes-files"? "active": ""} fs-5 font-monospace mx-2`}  to="/Notes-files">Notes/Files</Link>
                </li>
            </ul>
            <form className="d-flex" role="search">
              {detailnav()}
            </form>
            </div>
        </div>
        </nav>
       
    </>
  )
}

export default Navabar
